import {
  BatterySavingsDto,
  BatterySavingsModel,
  FirstThreeSixtySavingsEntryDto,
  FirstThreeSixtySavingsEntryModel,
  WallboxSavingsDto,
  WallboxSavingsModel,
} from '../../../system-data-handler/types'

/**
 * Transforms three sixty savings "Battery case" from backend model to model we want to use on frontend side
 */
export const batterySavingsDtoToModel = (dtos: BatterySavingsDto[]): BatterySavingsModel => {
  return dtos.reduce<BatterySavingsModel>(
    (accumulator, dto) => {
      accumulator.time += dto.time
      accumulator.consumedPower += dto.netOutWh
      accumulator.batterySavings += dto.savings
      accumulator.weightedPrice += dto.weightedPrice / dtos.length
      return accumulator
    },
    { time: 0, consumedPower: 0, batterySavings: 0, weightedPrice: 0 }
  )
}
/**
 * Transforms threesixty savings "Wallbox case" from backend  model to model we want to use on frontend side
 */
export const wallboxSavingsDtoToModel = (dtos: WallboxSavingsDto[]): WallboxSavingsModel => {
  return dtos.reduce<WallboxSavingsModel>(
    (accumulator, dto) => {
      accumulator.time += dto.time
      accumulator.consumedPower += dto.netOutWh
      accumulator.wallboxSavings += dto.savings
      accumulator.weightedPrice += dto.weightedPrice / dtos.length
      return accumulator
    },
    { time: 0, consumedPower: 0, wallboxSavings: 0, weightedPrice: 0 }
  )
}

export const firstSavingDtoToModel = (dto: FirstThreeSixtySavingsEntryDto): FirstThreeSixtySavingsEntryModel => {
  return {
    firstSavingsDate: dto.firstDate ?? undefined,
  }
}
